import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { LoginServico } from "../servicos/login.servico";
import { UtilServico } from "../servicos/util.servico";
import { Router, ActivatedRoute } from "@angular/router";
import { Console } from "@angular/core/src/console";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { DatePipe, registerLocaleData } from "@angular/common";
import { NativeDateAdapter, NativeDateModule } from "@angular/material";
import { CurrencyMaskModule } from "ngx-currency-mask";
import { Buffer } from 'buffer'
import {
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG,
} from "ngx-currency-mask/src/currency-mask.config";
import {
  FormControl,
  FormsModule,
  NgForm,
  FormBuilder,
  FormGroup,
  Validators,
  FormGroupDirective,
} from "@angular/forms";
import {
  ErrorStateMatcher,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
} from "@angular/material/core";
import { ResponseContentType } from "@angular/http";
import { saveAs } from "file-saver/FileSaver";
import { UtilDadosLogado } from "../servicos/util.logado";
import swal from "sweetalert2";
import localePt from "@angular/common/locales/pt";
import { DataSource } from "@angular/cdk/collections";
import { DomSanitizer } from "@angular/platform-browser";
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { Observable, ReplaySubject } from "rxjs";
import { map } from "rxjs/operators";
// import { setInterval } from 'timers';

registerLocaleData(localePt);

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
};

interface CustomFile {
  name: string;
  fullName: string;
  file: File;
  source: String | ArrayBuffer;
  angle: number;
  rotatedFile: File;
}


interface DocumentosAnexados {
  ARQUIVOS_PESSOAS_DOCUMENTOS_ID : number,
  TITULO: string,
  NAME: string,
  DADOS: any
}

let ELEMENT_DATA: CustomFile[] = [];

class ExampleDataSource extends DataSource<CustomFile> {
  private _dataStream = new ReplaySubject<CustomFile[]>();

  constructor(initialData: CustomFile[]) {
    super();
    this.setData(initialData);
  }

  connect(): Observable<CustomFile[]> {
    return this._dataStream;
  }

  disconnect() {}

  setData(data: CustomFile[]) {
    this._dataStream.next(data);
  }
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

export function matchValidator(fieldName: string) {
  let fcfirst: FormControl;
  let fcSecond: FormControl;

  return function matchValidator(control: FormControl) {
    if (!control.parent) {
      return null;
    }

    // INITIALIZING THE VALIDATOR.
    if (!fcfirst) {
      //INITIALIZING FormControl first
      fcfirst = control;
      fcSecond = control.parent.get(fieldName) as FormControl;

      //FormControl Second
      if (!fcSecond) {
        throw new Error(
          "matchValidator(): Second control is not found in the parent group!"
        );
      }

      fcSecond.valueChanges.subscribe(() => {
        fcfirst.updateValueAndValidity();
      });
    }

    if (!fcSecond) {
      return null;
    }

    if (fcSecond.value !== fcfirst.value) {
      return {
        matchOther: true,
      };
    }

    return null;
  };
}
const MOMENT_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM-YYYY",
  },
};

type ResultadoSimulacao = {
  simulacaoId: string;
  mensagemErro: string;
  novaDataCalculo: string;
};

export class InformPortal {
  INFORME_ID: number;
  USR_LOGIN_ID: number;
  DATA_VISUALIZACAO: string;
}
export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === "input") {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return date.toDateString();
    }
  }
}
//declare var swal: any;
declare var jquery: any;
declare var $: any;
@Component({
  selector: "app-inicial",
  templateUrl: "./inicial.component.html",
  styleUrls: ["./inicial.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MyDateAdapter },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_FORMATS },
  ],
})
export class InicialComponent implements OnInit {
  token : any;
  tokenSisprevweb: string;
  notificationCount: number = 0;
  userForm: FormGroup;
  password = "password";
  display = "none";
  //configuracoes: any;
  pesquisar: any;
  public nomeResultadoPergunta = "";
  Placar: any;
  DADOS: any;
  DADOS2: any;
  SENHA: any;
  TotalRegistro: number;
  PaginaAtual: number = 1;
  PaginaTotal: number = 25;
  Mostrar: any;
  DADOSSIMULACAO: any;
  eleicaoSelecionada: Number;
  DADOSSIMULACAOESPONTANEA: any;
  DADOSPESSOAIS: any;
  DADOSRENDIMENTOS: any;
  EXPLICACAOREGRA: any;
  EXPLICACAOREGRAEXPONTANEA: any;
  ABONO_PERMANENCIA: any;
  DADOS_CEDENTE_BOLETO: any;
  public DADOCONTRIB: any;
  public DADOHOLERITE: any;
  public DADOSFICHA: any;
  public parametros: any;
  confirmedFileToUpload: File | null = null;
  fileToUploadName: any;
  confirmedFileToUploadName: any;
  mostrarEnquete: boolean = false;
  dadosEnquete: any;
  visualizarModalAviso = false
  avisosPortal = []
  //public sub = "http://localhost:62195/api/Inicial/";
  //public sub = "http://localhost/webapiportales/api/Inicial/";
  //public sub = "http://proxima.sisprevweb.com.br/webapiportales/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
  // public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Inicial/";
  uf = [];
  cidades = [];
  segurados = [];
  nacionalidade = [];
  @ViewChild("myInput") myInputVariable;
  raca = [];
  FALE: any;
  assunto = [];
  BOLETOS_PORTAL = [];
  SOLIC_BENEF: any;
  assuntoSolicitacaoBenef = [];
  selectedAssuntoSolicitacaoBenefId: any;
  selectedAssuntoSolicitacaoBenef: any;

  public eleicoes = [];
  public candidatos = [];
  public todasEleicoes = [];
  public todasInscricoes = [];
  inscricaoSelecionada: Number;
  candidatoselecionado: Number;
  confirmarinscricao: boolean;
  confirmarvoto: boolean;
  fotoid: Number;
  public todosResultados = [];
  Nomecandidato: string;

  bytesPdf: any;
  bytesPdfTitle = "";

  displayedColumns: string[] = ["delete", "edit", "fullName", "name"];
  dataToDisplay = [...ELEMENT_DATA];
  file: File;
  fileName: string;
  dataSource = new ExampleDataSource(this.dataToDisplay);
  editMode: boolean = false;
  fileToUpload: File | null = null;

  public sexo: Array<Object> = [
    { ID: "M", NOME: "Masculino" },
    { ID: "F", NOME: "Feminino" },
  ];
  public estadocivil: Array<Object> = [
    { ID: 1, NOME: "SOLTEIRO(A)" },
    { ID: 2, NOME: "CASADO(A)" },
    { ID: 3, NOME: "VIÚVO(A)" },
    { ID: 4, NOME: "SEPARADO(A) JUDICIALMENTE" },
    { ID: 5, NOME: "DIVORCIADO(A)" },
    { ID: 6, NOME: "UNIÃO ESTÁVEL" },
    { ID: 9, NOME: "OUTROS(A)" },
  ];
  public apos: Array<Object> = [
    { ID: "S", NOME: "Sim - Professor" },
    { ID: "N", NOME: "Não" },
  ];
  public mes: Array<Object> = [
    { ID: 1, NOME: "Janeiro" },
    { ID: 2, NOME: "Fevereiro" },
    { ID: 3, NOME: "Março" },
    { ID: 4, NOME: "Abril" },
    { ID: 5, NOME: "Maio" },
    { ID: 6, NOME: "Junho" },
    { ID: 7, NOME: "Julho" },
    { ID: 8, NOME: "Agosto" },
    { ID: 9, NOME: "Setembro" },
    { ID: 10, NOME: "Outubro" },
    { ID: 11, NOME: "Novembro" },
    { ID: 12, NOME: "Dezembro" },
  ];
  public logradouro: Array<Object> = [
    { ID: 8, NOME: "Avenida" },
    { ID: 81, NOME: "Rua" },
    { ID: 100, NOME: "Travessa" },
    { ID: 77, NOME: "Quadra" },
    { ID: 65, NOME: "Praça" },
    { ID: 104, NOME: "Vila" },
    { ID: 4, NOME: "Alameda" },
    { ID: 31, NOME: "Estrada" },
    { ID: 90, NOME: "Rodovia" },
    { ID: 105, NOME: "Assentamento" },
    { ID: 106, NOME: "Condomínio" },
    { ID: 107, NOME: "Conjunto" },
    { ID: 108, NOME: "Distrito" },
    { ID: 109, NOME: "Fazenda" },
    { ID: 110, NOME: "Jardim" },
    { ID: 111, NOME: "Loteamento" },
    { ID: 112, NOME: "Parque" },
    { ID: 113, NOME: "Povoado" },
    { ID: 114, NOME: "Sítio" },
  ];
  selectedAssunto: any;
  selectedAssuntoId: any;
  isOcultarValor: any;
  isOcultarAbonoPerma: any;
  isOcultarDataPrevisao: any;
  public resultados = [];
  FormControl = new FormControl("", [Validators.required, Validators.email]);

  matcher = new MyErrorStateMatcher();

  informativos = [];
  links = [];
  perguntasFrequentes = [];
  DocumentosAnexados: DocumentosAnexados[] = [];
  recadastramentoOnline = [];
  recadastramentoOnlineData: any;
  agendDataIni: any;
  agendDataFim: any;
  agendDescricao: any;
  dependentes = [];
  recadastramentoOnlineExibir = false;
  ELEICAOPENDENTE: any;
  public resultadoView = false;
  constructor(
    private fBuilder: FormBuilder,
    private http: Http,
    private LoginServico: LoginServico,
    private UtilServico: UtilServico,
    private router: Router,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<MyDateAdapter>,
    private formBuilder: FormBuilder,
    public UtilDadosLogado: UtilDadosLogado,
    private sanitizer: DomSanitizer
  ) {
    this.dateAdapter.setLocale("ptb");
  }

  public getPDF(pdfData) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      "data:application/pdf;base64," + pdfData
    );
  }

  public CountNotification() {
    this.Mostrar = true;
    const token = this.UtilDadosLogado.DadosAcesso().TOKEN;

    if (token !== undefined || token !== null) {
      let headers = new Headers({
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': 'Bearer' + token
      });

      let options = new RequestOptions({ headers: headers });
      this.http
        .post(
          this.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/GetNotificarInformativos",
          JSON.stringify({
            USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
          }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            this.notificationCount = data;
          },
          error => {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Nenhum cadastrado!"
            });
          }
        ).add(() => this.Mostrar = false);
    } else {
      this.Mostrar = false;
    }
  }


  ngOnInit() {
    let contadorInterval = 0;
    let maxCliquesBtnRefresh = 3;
    this.tokenSisprevweb = 'rjp64LYPkNBXCquxl5xh';
    this.ELEICAOPENDENTE = true;
    this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO =
      this.datePipe.transform(
        this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO,
        "dd/MM/yyyy HH:mm:ss"
      );
    this.pesquisar = {
      PesquisarPor: 1,
      CadastroInLoco: "T",
      Concluido: "T",
      Categoria: 1,
    };
    this.DADOS = {};
    this.DADOS2 = {};
    this.DADOSSIMULACAO = { Codigo: 0 };
    this.DADOSSIMULACAOESPONTANEA = { Codigo: 0 };
    this.DADOCONTRIB = {
      MES_INICIO: new Date().getMonth() + 1,
      ANO_INICIO: new Date().getFullYear(),
      MES_FIM: new Date().getMonth() + 1,
      ANO_FIM: new Date().getFullYear(),
    };
    this.SENHA = {};
    this.FALE = {};
    this.SOLIC_BENEF = {
      DATA_ABERT: this.datePipe.transform(new Date(), "dd/MM/yyyy"),
      ASSUNTO_ID: "",
      DSC: "",
    };
    this.EXPLICACAOREGRA = {};
    this.DADOSPESSOAIS = {};
    this.parametros = {};
    this.DADOHOLERITE = {
      MES: new Date().getMonth() + 1,
      ANO: new Date().getFullYear(),
    };
    this.DADOSFICHA = { ANO: new Date().getFullYear() };
    this.DADOSRENDIMENTOS = { ANO: new Date().getFullYear() - 1 };
    this.GetSegurados();
    this.GetParametros();

    this.Assunto();
    this.RecadastramentoOnline();
    this.AssuntoSolicitarBeneficio();
    this.Informativos();
    this.Links();

    this.ConsultarEnquete();
    this.GetAvisosPortal();
    let intervalId = setInterval(function () {
      let btnClick = document.getElementById('btnRefresh');
      btnClick.click();
      contadorInterval++;
      if (contadorInterval >= maxCliquesBtnRefresh) {
        clearInterval(intervalId);
      }
    }, 10);

  }
  CarregarGridInicial(currentPage: number) {
    this.Mostrar = true;

    this.UtilServico.Post(
      "GetProcesso",
      JSON.stringify({
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        NOME: this.UtilDadosLogado.DadosAcesso().NOME,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.resultados = data.Resultado;
        if (this.TotalRegistro == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum processo encontrado",
          });
        }
      },
      (error) => {}
    );
  }

  public pageChanged(event: any): void {
    this.PaginaAtual = event;
    this.CarregarGridInicial(event);
  }

  public EditarClick() {
    this.CarregarGridInicial(1);
  }

  removeData(element: CustomFile) {
    if (confirm("Deseja realmente Excluir este arquivo?")) {
      this.dataToDisplay = this.dataToDisplay.filter((x) => x != element);

      this.dataSource.setData(this.dataToDisplay);

      ELEMENT_DATA = this.dataToDisplay;
    }
  }
  handleFileInput(files: FileList) {
    var ext = files.item(0).name.match(/\.([^\.]+)$/)[1];

    switch (ext.toLowerCase()) {
      case "gif":
      case "jpg":
      case "jpeg":
      case "pdf":
      case "doc":
      case "docx":
      case "xls":
      case "xlsx":
      case "rar":
      case "png":
        if (files.item(0).size / 1024 / 1024 <= 4) {
          this.fileToUpload = files.item(0);
        } else {
          this.fecharAnexoDoc();
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "O arquivo ultrapassou o limite de tamanho de 4 megas.",
          });
        }

        break;
      default:
        this.fecharAnexoDoc();

        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "A extensão " + ext + " não é suportada!",
        });

        this.myInputVariable.nativeElement.value = "";

        break;
    }
  }


  GetAvisosPortal() {
    this.UtilServico.Get("GetAvisosPortal?SEGURADO_ID=" + this.UtilDadosLogado.DadosAcesso().SEGURADO_ID)
      .subscribe(
        (data) => {
          if (data.length > 0) {
            this.avisosPortal = data
            $("#ModalAvisos").show();
          }
        },
        (error) => {

        }
    )

  }

  FecharModalAvisos() {
    $("#ModalAvisos").hide();

  }

  ConfirmUpload() {
    if (this.fileToUpload != null) {
      if (this.fileToUploadName) {
        this.confirmedFileToUpload = this.fileToUpload;
        this.confirmedFileToUploadName = this.fileToUploadName;
        this.fileToUploadName = null;
        this.fileToUpload = null;
        this.myInputVariable.nativeElement.value = "";
        const docTemporarios: DocumentosAnexados = {
          ARQUIVOS_PESSOAS_DOCUMENTOS_ID: 0,
          TITULO: this.confirmedFileToUploadName,
          NAME: this.confirmedFileToUpload.name,
          DADOS: undefined
        }
        this.DocumentosAnexados.push(docTemporarios)
        this.fecharAnexoDoc();

      } else {
        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "É obrigatório preencher o nome do arquivo!",
        });
        this.fileToUpload = null;
        this.myInputVariable.nativeElement.value = "";
      }
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "É obrigatório anexar um arquivo!",
      });
      this.fileToUpload = null;
      this.myInputVariable.nativeElement.value = "";
    }

    this.fecharAnexoDoc();
  }
  public fecharAnexoDoc() {
    $("#ModalAnexarDoc").hide();
    $("#ModalDadosPessoais").show();
    this.fileToUploadName = "";
  }
  public EnviarArquivosTMP(self, data): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let formData: any;
      let promises: any = [];

      for (let index = 0; index < self.dataToDisplay.length; index++) {
        formData = new FormData();

        formData.append("oFile", self.dataToDisplay[index].rotatedFile);
        formData.append("oFileName", self.dataToDisplay[index].name);
        formData.append("oFileFullName", self.dataToDisplay[index].fullName);
        formData.append("oPessoaId", self.DADOSPESSOAIS.PESSOA_ID);
        formData.append("oUserId", self.DADOSPESSOAIS.USR_LOGIN_ID);
        formData.append("oPessoaTmpId", data);
        formData.append("oIndex", (index + 1).toString());

        promises.push(self.EnviarArquivoTMP(self, formData));
      }

      Promise.all(promises)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        });
    });
  }


  public PutArquivosPessoas(self) {
    this.UtilServico.Put("PutArquivosPessoas",
     {
        ARQUIVOS_PESSOAS_DOCUMENTOS_ID: self.ARQUIVOS_PESSOAS_DOCUMENTOS_ID,
        NAME: this.editableName.length == 0 ? self.NAME : this.editableName.concat(".").trim() + self.NAME.split(".")[1],
        TITULO: this.editableFullName.length == 0 ? self.TITULO : this.editableFullName
     }
    ).subscribe(
      (data) => {
        this.editMode = false;
        this.GetArquivosPessoas()
      },
      (error) => {
      }
    )
  }

  public EnviarArquivoTMP(self, formData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      self.http
        .put(
          self.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/PutArquivosPessoasTmp",
          formData
        )
        .pipe(map((res: Response) => res.json()))
        .subscribe(
          (data) => {
            resolve(true);
          },
          (error) => {
            reject(false);
          }
        );
    });
  }

  public GetArquivosPessoas() {
    this.UtilServico.Get("GetArquivosPessoa?PESSOA_ID=" + this.UtilDadosLogado.DadosAcesso().PESSOA_ID)
      .subscribe(
        (data) => {
          this.DocumentosAnexados = data

        },
        (error) => { }
      )
  }


  public DeletarArquivo(self) {
    this.UtilServico.Post("DeletarArquivosPessoa",
      JSON.stringify({
        PESSOA_ID: self.PESSOA_ID,
        ARQUIVOS_PESSOAS_DOCUMENTOS_ID: self.ARQUIVOS_PESSOAS_DOCUMENTOS_ID
      })
    ).subscribe(
      (data) => {
        this.GetArquivosPessoas()
      }
    )
  }

  public EnviarArquivos(self): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let formData: any;
      let promises: any = [];

      for (let index = 0; index < self.dataToDisplay.length; index++) {
        formData = new FormData();

        formData.append("oFile", self.dataToDisplay[index].rotatedFile);
        formData.append("oFileName", self.dataToDisplay[index].name);
        formData.append("oFileFullName", self.dataToDisplay[index].fullName);
        formData.append("oPessoaId", self.DADOSPESSOAIS.PESSOA_ID);
        formData.append("oUserId", self.DADOSPESSOAIS.USR_LOGIN_ID);
        formData.append(
          "oIndex",
          (self.DADOSPESSOAIS.MAX_ORDER + (index + 1)).toString()
        );

        promises.push(self.EnviarArquivo(self, formData));
      }

      Promise.all(promises)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        });
    });
  }

  public EnviarArquivo(self, formData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      self.http
        .post(
          self.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/PostArquivosPessoas",
          formData
        )
        .pipe(map((res: Response) => res.json()))
        .subscribe(
          (data) => {
            resolve(true);
          },
          (error) => {
            reject(false);
          }
        );
    });
  }

  //#region simulacao
  public Simulacao() {
    this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), "dd/MM/yyyy");
    this.Mostrar = true;
    this.DADOSSIMULACAO.Codigo = 0;
    this.UtilServico.Post(
      "GetSimulacao",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.DADOS2 = data.Resultado[0];
        this.DADOS = this.DADOS2.Table[0];
        this.DADOS2.DATA_CALC = this.datePipe.transform(
          new Date(),
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_ADM = this.datePipe.transform(
          this.DADOS.DATA_ADM,
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_NASC = this.datePipe.transform(
          this.DADOS.DATA_NASC,
          "dd/MM/yyyy"
        );
        this.isOcultarAbonoPerma =data.OCULTABTN;
      },
      (error) => {}
    );
  }

  private ConverterData(dataString: string): Date | null {
    if (!dataString) return null;

    const partes = dataString.split("/");
    const dia = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1;
    const ano = parseInt(partes[2], 10);

    return new Date(ano, mes, dia);
  }

  public SimularSegurado(simulacaoId: string) {
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);

    const dataInserida = this.ConverterData(this.DADOS2.DATA_CALC);

    if (!dataInserida || isNaN(dataInserida.getTime())) {
      swal.fire({
        title: "Data Inválida!",
        type: "error",
        text: "A data de cálculo não é válida.",
      });
      return;
    }

    if (dataInserida > dataAtual) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A data da simulação não poderá ser superior à data atual!",
      });
      return;
    }

    this.ABONO_PERMANENCIA = "N";
    this.Mostrar = true;
    this.UtilServico.Post(
      "SimularSegurado",
      JSON.stringify({
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_NASC: this.DADOS.DATA_NASC,
        IDADE: this.DADOS.IDADE,
        ABONO_PERMANENCIA: "N",
        SIMULACAO_ID: simulacaoId
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSSIMULACAO = data;
        if (data.Codigo == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.DADOSSIMULACAO.Codigo = 1;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          this.isOcultarDataPrevisao =data.OCULTAR_COLUNA_DATA;
          this.isOcultarValor = data.OCUTAR_COLUNA_VALOR;
        }
      },
      (error) => {}
    );
  }
  public ResultadoSimulacao(event: any) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetResultadoSimulacao",
        JSON.stringify({
          RESULTADO_SIMULACAO_ID: event.RESULTADO_SIMULACAO_ID,
          SIMULA_REQUISITO_ID: event.SIMULA_REQUISITO_ID,
          TmpCarreira: event.TmpCarreira,
          SIMULA_ABONO: this.ABONO_PERMANENCIA,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ResultadoSimulacao.pdf");
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }
  public ExplicacaoRegra(event: any) {
    this.EXPLICACAOREGRA = event;
    $("#ModalSimulacaoExplicao").show();
    $("#ModalSimulacao").hide();
  }
  public SairExplicacaoRegra() {
    $("#ModalSimulacaoExplicao").hide();
    $("#ModalSimulacao").show();
  }
  public SimularSeguradoAbono(event: any) {

    const dataAtual = new Date();
    dataAtual.setHours(0,0,0,0);

    const dataInserida = this.ConverterData(this.DADOS2.DATA_CALC);

    if (!dataInserida || isNaN(dataInserida.getTime())) {
      swal.fire({
        title: "Data Inválida!",
        type: "error",
        text: "A data de cálculo não é válida.",
      });
      return;
    }

    if (dataInserida > dataAtual) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A data da simulação não poderá ser superior à data atual!",
      });
      return;
    }

    this.ABONO_PERMANENCIA = "S";
    this.Mostrar = true;
    this.UtilServico.Post(
      "SimularSegurado",
      JSON.stringify({
        SEGURADO_ID: event,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_NASC: this.DADOS.DATA_NASC,
        IDADE: this.DADOS.IDADE,
        ABONO_PERMANENCIA: "S",
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSSIMULACAO = data;
        if (data.Codigo == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.DADOSSIMULACAO.Codigo = 1;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          this.isOcultarValor = data.OCUTAR_COLUNA_VALOR;
          this.isOcultarDataPrevisao = data.OCULTAR_COLUNA_DATA;
        }
      },
      (error) => {}
    );
  }

  public SimulacaoSisprevWeb() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL_SISPREV + "/WebService/WebServiceSimulacao.asmx/SimulacaoSisprevWeb", JSON.stringify(
      {
        token: this.tokenSisprevweb,
        seguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        dataCalc: this.DADOS2.DATA_CALC,
        isEspecial: false,
        isSisprev: false
      }), options)
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.TransformaSimulacaoId(data).then((res: ResultadoSimulacao) => {
            if (res.simulacaoId == "0") {
              this.Mostrar = false;
              if (res.mensagemErro.length > 0) {
                swal.fire({
                  title: "Atenção!",
                  type: "error",
                  text: res.mensagemErro,
                });
                this.DADOS2.DATA_CALC = res.novaDataCalculo;
              } else {
                swal.fire({
                  title: "Atenção!",
                  type: "error",
                  text: "Não foi possível realizar a simulação",
                });
              }
            } else {
              this.SimularSegurado(res.simulacaoId);
            }
          });
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }
  //#endregion simulacao

  //#region simulacaoespontanea
  public ExplicacaoRegraExpontanea(event: any) {
    this.EXPLICACAOREGRAEXPONTANEA = event;
    $("#ModalSimulacaoExplicaoExpontanea").show();
    $("#ModalSimulacaoEspontanea").hide();
  }
  public SairExplicacaoRegraExpontanea() {
    $("#ModalSimulacaoExplicaoExpontanea").hide();
    $("#ModalSimulacaoEspontanea").show();
  }
  public SimulacaoEspontanea() {
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetSimulacaoEspontanea",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
      })
    ).subscribe(
      (data) => {


        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.DADOS2 = data.Resultado[0];
        this.DADOS = this.DADOS2.Table[0];
        this.DADOS.DATA_ADM = this.datePipe.transform(
          this.DADOS.DATA_ADM,
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_NASC = this.datePipe.transform(
          this.DADOS.DATA_NASC,
          "dd/MM/yyyy"
        );
        this.DADOS.ESPECIAL = "N";
        this.DADOS2.DATA_CALC = this.datePipe.transform(
          new Date(),
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_CALC = this.DADOS2.DATA_CALC;

        this.isOcultarAbonoPerma = false;
      },
      (error) => {}
    );
  }
  public SimularEspontanea(event: any) {
    this.Mostrar = true;
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.UtilServico.Post(
      "GetGerarSimulacaoEspontanea",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_ADM: this.DADOS.DATA_ADM,
        ESPECIAL: this.DADOS.ESPECIAL,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSSIMULACAOESPONTANEA = data;
        if (data.Codigo == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.DADOSSIMULACAOESPONTANEA.Codigo = 1;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
        }
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }

  //#endregion simulacaoespontanea

  public Processos(event: any, tipo: any) {
    if (
      this.parametros.PORTAL_HISTORICO_PROCESSO == "N" &&
      this.parametros.PORTAL_MEUS_PROCESSOS == true
    )
      return;

    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHistorico",
        JSON.stringify({ PROCESSO_ID: event, TIPO_PROCESSO: tipo }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "HistoricoProcesso.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  AlterSenha() {
    this.Mostrar = true;
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!",
      });
    } else {
      this.UtilServico.Post(
        "GetTrocarSenha",
        JSON.stringify({
          ATUAL: this.SENHA.ATUAL,
          NOVA: this.SENHA.NOVA,
          LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        })
      ).subscribe(
        (data) => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          if (this.TotalRegistro == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Senha atual não confere!",
            });
          } else {
            swal.fire({
              title: "Atenção!",
              type: "success",
              text: "Senha alterada com sucesso!",
            });
            $("#ModalTrocarSenha").hide();
            $(document.body).removeClass("modal-open");
            $(".modal-backdrop").remove();
          }
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    }
  }

  //#region faleconosco
  Assunto() {
    if (this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL != null)
      this.FALE.FONE_RESIDENCIAL =
        this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL;
    if (this.UtilDadosLogado.DadosAcesso().EMAIL1 != null)
      this.FALE.EMAIL1 = this.UtilDadosLogado.DadosAcesso().EMAIL1;
    this.UtilServico.Get("GetAssunto").subscribe(
      (data) => (this.assunto = data),
      (error) => {}
    );
  }
  setAssunto($event) {
    this.selectedAssuntoId = $event;
    for (var i = 0; i < this.assunto.length; i++) {
      if (this.assunto[i].ASSUNTO_ID == $event) {
        this.selectedAssunto = this.assunto[i].NOME;
      }
    }
  }

  FaleConosco() {
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetFaleConosco",
      JSON.stringify({
        ASSUNTO_ID: this.selectedAssuntoId,
        ASSUNTO_NOME: this.selectedAssunto,
        EMAIL1: this.FALE.EMAIL1,
        FONE_RESIDENCIAL: this.FALE.FONE_RESIDENCIAL,
        DSC_ASSUNTO: this.FALE.DSC_ASSUNTO,
        NOME: this.UtilDadosLogado.DadosAcesso().NOME,
        USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        SEXO: this.UtilDadosLogado.DadosAcesso().SEXO,
      })
    ).subscribe(
      (data) => {
        this.TotalRegistro = data.Total;
        this.Mostrar = false;
        swal.fire({
          title: "Atenção!",
          type: "success",
          text: "Email encaminhado com sucesso!",
        });
      },
      (error) => {
        this.Mostrar = false;
        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "Favor verificar se os parâmetros estão preenchidos corretamente!",
        });
      }
    );
  }
  //#endregion faleconosco

  //#region dadospessoais
  GetUf() {
    this.UtilServico.Get("GetUf").subscribe(
      (data) => {
        this.uf = data;
      },
      (error) => {}
    );
  }
  GetCidades() {
    this.UtilServico.Get(
      "GetCidades/" + this.DADOSPESSOAIS.UF_NASCIMENTO
    ).subscribe(
      (data) => {
        this.cidades = data;
      },
      (error) => {}
    );
  }
  GetSegurados() {
    this.UtilServico.Get(
      "GetSegurados/" + this.UtilDadosLogado.DadosAcesso().PESSOA_ID
    ).subscribe(
      (data) => {
        this.segurados = data;
      },
      (error) => {}
    );
  }

  public ConsultarEnquete() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/ConsultarEnquete",
        JSON.stringify({
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        }),
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;

          this.dadosEnquete = data.SUCCESS ? data : null;
          this.mostrarEnquete = data.SUCCESS;
        },
        (error) => {
          this.Mostrar = false;
          this.mostrarEnquete = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Ocorreu erro na consulta das enquetes!",
          });
        }
      );
  }

  EmitirProtocoloRecadastramento() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/ImprimirProtocolo",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          if (window.navigator.msSaveOrOpenBlob) {
            //IE & Edge
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ProtocoloRecadastramento.pdf");
          } else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }

          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  GetSeguradoInfo(event) {
    const token = this.UtilDadosLogado.DadosAcesso().TOKEN;

    this.Mostrar = true;
    this.UtilServico.Get("GetSeguradoInfo/" + event).subscribe(
      (data) => {

        localStorage.setItem(
          "AcessoAdm",
          JSON.stringify(
            Object.assign(data, { URL: this.UtilDadosLogado.DadosAcesso().URL, TOKEN : token  })
          )
        );
        this.GetParametros();
        this.Mostrar = false;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
    if (this.parametros.PORTAL_OCULTA_OPCAO_FOLHA_PROCESSADA_VAZIA == "S") {
      this.GetInfFinanceiraSegurado(event);
    }
  }
  GetInfFinanceiraSegurado(event) {
    this.Mostrar = true;
    this.UtilServico.Get("GetInfFinanceiraSegurado/" + event).subscribe(
      (data) => {
        this.parametros.PORTAL_HOLERITE_CONTRACHEQUE = data;
        this.parametros.PORTAL_FICHA_FINANCEIRA = data;
        this.parametros.PORTAL_CRP = data == true ? "S" : "N";
        this.Mostrar = false;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }
  upload() {}
  GetNacionalidade() {
    this.UtilServico.Get("GetNacionalidade").subscribe(
      (data) => {
        this.nacionalidade = data;
      },
      (error) => {}
    );
  }
  GetRaca() {
    this.UtilServico.Get("GetRaca").subscribe(
      (data) => {
        this.raca = data;
      },
      (error) => {}
    );
  }

  Pessoas() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.GetArquivosPessoas();
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetPessoas",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSPESSOAIS = data.Resultado;

        this.DADOSPESSOAIS.DATA_NASC = this.datePipe.transform(
          this.DADOSPESSOAIS.DATA_NASC,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.RG_DT_EMISSAO = this.datePipe.transform(
          this.DADOSPESSOAIS.RG_DT_EMISSAO,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.CTPS_DT_EMISSAO = this.datePipe.transform(
          this.DADOSPESSOAIS.CTPS_DT_EMISSAO,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.UF_NASCIMENTO = data.UF;
        this.DADOSPESSOAIS.END_UF = data.END_UF;
        if (this.DADOSPESSOAIS.UF_NASCIMENTO != null) this.GetCidades();
        if (this.DADOSPESSOAIS.NACIONALIDADE_ID == null)
          this.DADOSPESSOAIS.NACIONALIDADE_ID = 25;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }
  public SalvarPessoas() {
    this.Mostrar = true;
    let body = this.DADOSPESSOAIS;


    const formData: any = new FormData();

    $.each(this.dataToDisplay, function (i, file) {
      formData.append("oFile" + i, file.rotatedFile);
      formData.append("oFileName" + i, file.name);
      formData.append("oFileFullName" + i, file.fullName);
    });

    formData.append("oPessoaId", this.DADOSPESSOAIS.PESSOA_ID);
    formData.append("oUserId", this.DADOSPESSOAIS.USR_LOGIN_ID);
    if (this.parametros.PORTAL_CADASTRO_DIRETO === "S") {
      this.UtilServico.Put(
        "PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID,
        body
      ).subscribe(
        (data) => {

          this.http
            .post(
              this.UtilDadosLogado.DadosAcesso().URL +
              "/api/Inicial/PostArquivosPessoas",
              formData
            )
            .pipe(map((res: Response) => res.json()))
            .subscribe(
              (data) => {
                this.Mostrar = false;
                swal.fire({
                  title: "Atenção!",
                  type: "success",
                  text: "Cadastro atualizado com sucesso!",
                });
                this.GetArquivosPessoas()
                this.dataToDisplay = []
              },
              (error) => {
                this.Mostrar = false;
              }
            );
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    } else {
      this.UtilServico.Put(
        "PutrPESSOAS_TMP/" + this.DADOSPESSOAIS.PESSOA_ID,
        body
      ).subscribe(
        (data) => {
          formData.append("oPessoaTmpId", data);
          this.http
            .put(
              this.UtilDadosLogado.DadosAcesso().URL +
              "/api/Inicial/PutArquivosPessoasTmp",
              formData
            )
            .pipe(map((res: Response) => res.json()))
            .subscribe(
              (data) => {
                this.Mostrar = false;
                swal.fire({
                  title: "Sucesso!",
                  type: "success",
                  text: "Solicitação enviada para análise!",
                });
              },
              (error) => {
                this.Mostrar = false;
              }
            );
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    }
  }

  enableEditIndex = null;
  editableName: string = "";
  editableFullName: string = "";
  editableExt: string = "";
  mostrarImagens: boolean = false;
  urlImage: String | ArrayBuffer;

  trocaImagens() {
    this.mostrarImagens = !this.mostrarImagens;
  }

  ngDoCheck(): void {
    if (this.confirmedFileToUpload != null) {
      ELEMENT_DATA.push({
        name: this.confirmedFileToUpload.name,
        fullName: this.confirmedFileToUploadName,
        file: this.confirmedFileToUpload,
        source: "",
        angle: 0,
        rotatedFile: this.confirmedFileToUpload,
      });

      this.carregarImagem(ELEMENT_DATA, ELEMENT_DATA.length - 1);

      this.confirmedFileToUpload = null;

      this.confirmedFileToUploadName = null;

      this.dataToDisplay = [...ELEMENT_DATA];

      this.dataSource = new ExampleDataSource(this.dataToDisplay);
    }
  }

  carregarImagem(listOfFiles: CustomFile[], index: number) {
    var mimeType = listOfFiles[index].file.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(listOfFiles[index].file);
    reader.onload = (_event) => {
      listOfFiles[index].source = reader.result;
    };
  }

  enableEditMethod(element: CustomFile) {
    this.editableExt = "." + element.name.match(/\.([^\.]+)$/)[1];
    this.editableName = element.name.split(".").slice(0, -1).join(".");
    this.editableFullName = element.fullName;
    const index = this.dataToDisplay.indexOf(element);
    this.editMode = true;
    this.enableEditIndex = index;
  }

  addData() {
    const randomElementIndex = Math.floor(Math.random() * ELEMENT_DATA.length);
    this.dataToDisplay = [
      ...this.dataToDisplay,
      ELEMENT_DATA[randomElementIndex],
    ];
    this.dataSource.setData(this.dataToDisplay);
  }

  saveChanges(self) {
    if (this.editableName) {
      const novoItem: CustomFile = {
          name: self.NAME,
          fullName: self.TITULO,
          file: self.DADOS,
          source: "",
          angle: 0,
          rotatedFile: self.DADOS
      }
      this.dataToDisplay.push(novoItem)

      const index = this.dataToDisplay.indexOf(novoItem);



      this.dataToDisplay[index].name = this.editableName + this.editableExt;
      this.dataToDisplay[index].fullName = this.editableFullName;

      this.editMode = false;
      this.enableEditIndex = null;
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "O preenchimento dos campos é obrigatório!",
      });
    }
  }

  EditarItem(index) {
    this.editMode = true;
    this.enableEditIndex = index;
  }

  girarImagemEsquerda(index: number) {
    const formData: any = new FormData();

    let angle = this.dataToDisplay[index].angle - 90;

    var alpha = angle;
    while (alpha < 0) {
      alpha += 360;
    }

    while (alpha > 360) {
      alpha -= 360;
    }

    this.dataToDisplay[index].angle = alpha;

    formData.append("oFile", this.dataToDisplay[index].file);
    formData.append("oAngle", this.dataToDisplay[index].angle);

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/RotateImage",
        formData,
        { responseType: ResponseContentType.Blob }
      )
      .pipe(map((res: Response) => res.json()))
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var blob = new Blob([data], {
            type: this.dataToDisplay[index].file.type,
          });

          this.dataToDisplay[index].rotatedFile = new File(
            [blob],
            this.dataToDisplay[index].file.name,
            { type: this.dataToDisplay[index].file.type }
          );

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (_event) => {
            this.dataToDisplay[index].source = reader.result;
          };
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }

  downloadFile(self) {

    const element: CustomFile = {
      name: self.NAME,
      fullName: self.TITULO,
      file: self.DADOS,
      source: "",
      angle: 0,
      rotatedFile: self.DADOS
    }
    var buffer = Buffer.from(self.DADOS, "base64");

    var file = new Blob([buffer], { type: "image/" + element.name.split(".")[1] });

    var reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (_event) => {
      var fileURL = URL.createObjectURL(file);
      var width = window.innerWidth;
      var height = (width * window.innerHeight) / window.innerWidth;

      switch (element.name.match(/\.([^\.]+)$/)[1].toLowerCase()) {
        case "png":
        case "jpeg":
        case "jpg":
        case "gif":
        case "pdf":
          window.open(
            fileURL,
            "newwindow",
            "width=" + width + ",height=" + height
          );
          break;
        default:
          window.open(fileURL, "_blank");
      }
    };
  }

  girarImagemDireita(index: number) {
    const formData: any = new FormData();

    let angle = this.dataToDisplay[index].angle + 90;

    var alpha = angle;
    while (alpha < 0) {
      alpha += 360;
    }

    while (alpha > 360) {
      alpha -= 360;
    }

    this.dataToDisplay[index].angle = alpha;

    formData.append("oFile", this.dataToDisplay[index].file);
    formData.append("oAngle", this.dataToDisplay[index].angle);

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/RotateImage",
        formData,
        { responseType: ResponseContentType.Blob }
      )
      .pipe(map((res: Response) => res.json()))
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var blob = new Blob([data], {
            type: this.dataToDisplay[index].file.type,
          });

          this.dataToDisplay[index].rotatedFile = new File(
            [blob],
            this.dataToDisplay[index].file.name,
            { type: this.dataToDisplay[index].file.type }
          );

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (_event) => {
            this.dataToDisplay[index].source = reader.result;
          };
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }

  moveUp(element: CustomFile): void {
    const index = this.dataToDisplay.indexOf(element);
    if (index === 0) {
      // can not move higher
      return;
    }
    const swap = this.dataToDisplay[index - 1];
    this.dataToDisplay[index - 1] = element;
    this.dataToDisplay[index] = swap;
    this.dataSource.setData(this.dataToDisplay);
    ELEMENT_DATA = this.dataToDisplay;
  }

  moveDown(element: CustomFile): void {
    const index = this.dataToDisplay.indexOf(element);
    if (index === this.dataToDisplay.length - 1) {
      // can not move higher
      return;
    }
    const swap = this.dataToDisplay[index + 1];
    this.dataToDisplay[index + 1] = element;
    this.dataToDisplay[index] = swap;
    this.dataSource.setData(this.dataToDisplay);
    ELEMENT_DATA = this.dataToDisplay;
  }

  public anexarDocumentos() {
    $("#ModalAnexarDoc").show();
    $("#ModalDadosPessoais").hide();
  }
  //#endregion dadospessoais

  //region extratocontrib
  public EmitirExtrato() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetExtratoContrib",
        JSON.stringify({
          MES_INICIO: this.DADOCONTRIB.MES_INICIO,
          ANO_INICIO: this.DADOCONTRIB.ANO_INICIO,
          MES_FIM: this.DADOCONTRIB.MES_FIM,
          ANO_FIM: this.DADOCONTRIB.ANO_FIM,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ExtratoContribuicao.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion extratocontrib

  //#region holerite
  public EmitirHolerite() {
    const token = this.UtilDadosLogado.DadosAcesso().TOKEN;
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
      'Authorization': 'Bearer ' + token,
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHolerite",
        JSON.stringify({
          MES_INICIO: this.DADOHOLERITE.MES,
          ANO_INICIO: this.DADOHOLERITE.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          DECIMO: this.DADOHOLERITE.DECIMO,
          SUPLEMENTAR: this.DADOHOLERITE.SUPLEMENTAR,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "Holerite.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  public EmitirHoleriteSisprevWeb() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL_SISPREV + "/WebService/WebServiceHolerite.asmx/HoleritePortal", JSON.stringify(
      {
        token: this.tokenSisprevweb,
        seguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        ano: this.DADOHOLERITE.ANO,
        mes: this.DADOHOLERITE.MES,
        decimoTerceiro: this.DADOHOLERITE.DECIMO ? true : false
      }), options)
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, `Contracheque ${this.DADOHOLERITE.MES}-${this.DADOHOLERITE.ANO}`);
          var file = new Blob([data], { type: 'application/pdf' });
          saveAs(file, this.bytesPdfTitle + ".pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  //#endregion holerite

  //#region fichafinanceira
  public EmitirFichaFinanceira() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetFichaFinanceira",
        JSON.stringify({
          ANO_INICIO: this.DADOSFICHA.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "FichaFinanceira.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  public EmitirFichaFinanceiraSisprevWeb() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL_SISPREV + "/WebService/WebServiceFichaFinanceira.asmx/EmiteFichaFinanceiraPortal", JSON.stringify(
      {
        token: this.tokenSisprevweb,
        seguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        matOrg: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        categoriaId: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        ano: this.DADOSFICHA.ANO
      }), options)
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, `Ficha financeira ${this.DADOSFICHA.ANO}`);
          var file = new Blob([data], { type: 'application/pdf' });
          saveAs(file, this.bytesPdfTitle + ".pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion fichafinanceira

  //region rendimentospagos
  public EmitirComprovanteRendimentos() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/ComprovanteRendimentos",
        JSON.stringify({
          ANO_INICIO: this.DADOSRENDIMENTOS.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  public EmitirComprovanteRendimentosSisprevWeb() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL_SISPREV + "/WebService/WebServiceRendimentosPagos.asmx/EmiteComprovantePortal", JSON.stringify(
      {
        token: this.tokenSisprevweb,
        seguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        ano: this.DADOSRENDIMENTOS.ANO,
        pessoaId: this.UtilDadosLogado.DadosAcesso().PESSOA_ID
      }), options)
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, `Rendimentos Pagos ${this.DADOSRENDIMENTOS.ANO}`);
          var file = new Blob([data], { type: 'application/pdf' });
          saveAs(file, this.bytesPdfTitle + ".pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion rendimentospados

  VoltarDoResultado() {
    this.resultadoView = false;
    this.eleicaoSelecionada = null;

  }
  //regioneleicoes
  GetEleicoes(): void {
    var acessoAdmEleicao = JSON.parse(localStorage.getItem("AcessoAdm"));
    this.UtilServico.Get(
      "GetEleicoes/" +
      this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID +
      "/" +
      acessoAdmEleicao.SEGURADO_ID
    ).subscribe(
      (data) => {
        this.eleicoes = data;

        if (this.eleicoes.length > 0) {
          this.GetCandidatos();
          this.ELEICAOPENDENTE = true;
        } else {
          this.UtilServico.Get(
            "GetTodasEleicoes/" +
            this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID +
            "/" +
            acessoAdmEleicao.SEGURADO_ID
          ).subscribe(
            (data) => {
              this.todasEleicoes = data;
              this.ELEICAOPENDENTE = !(data.length > 0);
            },
            (error) => {
              this.ELEICAOPENDENTE = true;
            }
          );
        }
      },
      (error) => {}
    );
  }

  GetEleicaoResultado(id_eleicao: Number) {
    this.Mostrar = true;
    var acessoAdmEleicao = JSON.parse(localStorage.getItem("AcessoAdm"));
    this.UtilServico.Get(
      "GetResultadoEleicao/" + id_eleicao + "/" + acessoAdmEleicao.SEGURADO_ID
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.todosResultados = data;
        this.resultadoView = true;
      },
      (error) => {
        this.Mostrar = false;
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Não foi possível carregar os resultados!",
        });
        this.resultadoView = false;
      }
    );
  }
  GetInscricoes(): void {
    this.Mostrar = true;
    this.UtilServico.Get(
      "GetTodasInscricoes/" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.todasInscricoes = data;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }
  SelecionarCandidato(candidato_id: number) {
    if (
      this.candidatoselecionado == null ||
      this.candidatoselecionado == undefined
    ) {
      this.candidatoselecionado = candidato_id;
    } else {
      this.candidatoselecionado = null;
    }
  }

  SelecionarEleicao(eleicao_id: number, index: number) {
    if (
      this.eleicaoSelecionada == null ||
      this.eleicaoSelecionada == undefined
    ) {
      this.eleicaoSelecionada = eleicao_id;
      this.nomeResultadoPergunta = this.todasEleicoes[index].PERGUNTA;
    } else {
      this.eleicaoSelecionada = null;
    }
  }

  InscreverseNaEleicao() {
    if (
      this.inscricaoSelecionada != null ||
      this.inscricaoSelecionada != undefined
    ) {
      this.confirmarinscricao = true;
    } else {
      swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Selecione uma eleição!",
      });
    }
  }
  AbrirResultado() {
    if (
      this.eleicaoSelecionada != null ||
      this.eleicaoSelecionada != undefined
    ) {
      this.GetEleicaoResultado(this.eleicaoSelecionada);
    } else {
      swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Selecione uma eleição!",
      });
    }
  }

  SelecionarInscricao(eleicao_id: number, index: number) {
    if (
      this.inscricaoSelecionada == null ||
      this.inscricaoSelecionada == undefined
    ) {
      this.inscricaoSelecionada = eleicao_id;
    } else {
      this.inscricaoSelecionada = null;
    }
  }

  CancelarInscricao() {
    this.confirmarinscricao = false;
    this.inscricaoSelecionada = null;
  }

  ConfirmarInscricao() {
    this.validarInscricao();
  }

  public mudarResposta(id: any) {
    for (let index = 0; index < this.dadosEnquete.RESPOSTAS.length; index++) {
      if (id == this.dadosEnquete.RESPOSTAS[index].ENQUETE_RESPOSTA_ID) {
        this.dadosEnquete.RESPOSTAS[index].SELECTED = true;
      } else {
        this.dadosEnquete.RESPOSTAS[index].SELECTED = false;
      }
    }
  }

  public enqueteVotar() {
    for (let index = 0; index < this.dadosEnquete.RESPOSTAS.length; index++) {
      if (this.dadosEnquete.RESPOSTAS[index].SELECTED) {
        this.Mostrar = true;
        let headers = new Headers({
          "Content-Type": "application/json; charset=utf-8",
        });
        let options = new RequestOptions({ headers: headers });

        this.http
          .post(
            this.UtilDadosLogado.DadosAcesso().URL +
            "/api/Inicial/VotarEnquete",
            JSON.stringify({
              ENQUETE_RESPOSTA_ID:
                this.dadosEnquete.RESPOSTAS[index].ENQUETE_RESPOSTA_ID,
              USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
            }),
            options
          )
          .map((response: Response) => response.json())
          .subscribe(
            (data) => {
              this.Mostrar = false;

              this.dadosEnquete = null;
              this.mostrarEnquete = false;

              swal.fire({
                title: "Sucesso!",
                type: "success",
                text: "A enquete foi votada com sucesso!",
              });
            },
            (error) => {
              this.Mostrar = false;
              this.mostrarEnquete = false;
              swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Ocorreu erro no momento da votação da enquete!",
              });
            }
          );
      }
    }
  }

  validarInscricao(): void {
    this.Mostrar = true;
    this.UtilServico.Post(
      "ValidarInscricao",
      JSON.stringify({
        ENQUETE_PERGUNTA_ID: this.inscricaoSelecionada,
        USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;

        if ((data.Sucesso = 1)) {
          swal.fire({
            title: "PARABÉNS!",
            type: "success",
            text: "INSCRIÇÃO CONCLUÍDA COM SUCESSO!",
          });
        } else {
          swal.fire({
            title: "ERRO!",
            type: "error",
            text: "NÃO FOI POSSÍVEL REGISTRAR A INSCRIÇÃO!",
          });
        }

        this.CancelarInscricao();
        this.GetInscricoes();
      },
      (error) => {
        swal.fire({
          title: "ERRO!",
          type: "error",
          text: "NÃO FOI POSSÍVEL REGISTRAR A INSCRIÇÃO!",
        });
      }
    );
  }

  VotarNoCandidato() {
    if (
      this.candidatoselecionado != null ||
      this.candidatoselecionado != undefined
    ) {
      this.confirmarvoto = true;
    } else {
      swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Selecione um candidato!",
      });
    }
  }

  CancelarVoto() {
    this.confirmarvoto = false;
    this.candidatoselecionado = null;
  }

  ConfirmarVoto() {
    this.GetValidarVoto();
  }

  AumentarFotoCandidato(candidato_id: number, candidato_nome: string) {
    if (this.fotoid == null || this.fotoid == undefined) {
      this.Nomecandidato = candidato_nome;
      this.fotoid = candidato_id;
    } else {
      this.fotoid = null;
      this.Nomecandidato = null;
    }
  }

  GetValidarVoto(): void {
    this.UtilServico.Get(
      "GetValidarVoto?&id=" +
      this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID +
      "&resposta_id=" +
      this.candidatoselecionado
    ).subscribe(
      (data) => {
        swal.fire({
          title: "Obrigado!",
          type: "success",
          text: "Seu voto foi computado com sucesso!",
        });
        this.candidatos = [];
        this.eleicoes = [];
        this.candidatoselecionado = null;
        this.confirmarvoto = false;
        this.fotoid = null;
        this.GetEleicoes();
      },
      (error) => {
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Não foi possível confirmar seu voto no momento!",
        });
      }
    );
  }

  GetCandidatos(): void {
    var acessoAdmEleicao = JSON.parse(localStorage.getItem("AcessoAdm"));
    this.UtilServico.Get(
      "GetCandidatos/" +
      this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID +
      "/" +
      acessoAdmEleicao.SEGURADO_ID
    ).subscribe(
      (data) => {
        this.candidatos = data;
      },
      (error) => {}
    );
  }
  //endregioneleicoes

  //region parametros
  GetParametros(): void {
    this.UtilServico.Get(
      "GetParametros?&seguradoId=" +
      this.UtilDadosLogado.DadosAcesso().SEGURADO_ID
    ).subscribe(
      (data) => {
        console.log(data);
        this.parametros = { ...data.parametrosPortal, ...data.parametrosRecad };
        console.log(this.parametros);
        this.GetInscricoes();
        this.GetEleicoes();

      },
      (error) => {}
    );
  }
  //#endregion parametros
  Recadastramento() {
    localStorage.setItem(
      "AcessoCenso",
      JSON.stringify(
        Object.assign(this.UtilDadosLogado.DadosAcesso(), {
          Parametro: this.parametros.PORTAL_CADASTRO_DIRETO,
        })
      )
    );
    //window.open("http://201.62.46.58/CensoPortal/portal/?PESSOA_ID="+this.UtilDadosLogado.DadosAcesso().PESSOA_ID+"/?CategoriaId="+this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID+"/?SeguradoId="+this.UtilDadosLogado.DadosAcesso().SEGURADO_ID+"/?Parametro="+this.parametros.PORTAL_CADASTRO_DIRETO, "_blank");
    // window.open("http://201.62.44.57/CensoPortal/portal/", "_blank");
    //window.open("http://201.62.46.58/CensoPortal/portal/", "_blank");
    window.open(
      "http://localhost:62768/Portal/?PESSOA_ID=" +
      this.UtilDadosLogado.DadosAcesso().PESSOA_ID +
      "/?CategoriaId=" +
      this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID +
      "/?SeguradoId=" +
      this.UtilDadosLogado.DadosAcesso().SEGURADO_ID +
      "/?Parametro=" +
      this.parametros.PORTAL_CADASTRO_DIRETO,
      "_blank"
    );
    //window.open("http://proxima.sisprevweb.com.br/CensoPortalEs/portal/","_blank");
  }

  logout() {
    localStorage.removeItem("AcessoAdm");
    this.router.navigate(["/login"]);
  }

  //#region Recadastramento
  //#region Boleto Arrecadação

  public BoletoArrecadacao() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetBoletos",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        }),
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          this.BOLETOS_PORTAL = data;
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  EmitirBoletoArrecadacao(PARCELA_ID: any) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GeraDadosBoleto",
        JSON.stringify({
          PARCELA_ID: PARCELA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;

          if (this.isTypedArray(data) == true) {
            var file = new Blob([data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            saveAs(file, "BoletoArrecadacao.pdf");
          } else {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Nenhum registo encontrado!",
            });
          }
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  SetarDadosCendente(DADOS_BOLETO: any) {
    if (DADOS_BOLETO != null && DADOS_BOLETO.length > 0) {
      this.DADOS_CEDENTE_BOLETO.CEDENTE = DADOS_BOLETO.CEDENTE;
      this.DADOS_CEDENTE_BOLETO.COMPETENCIA = DADOS_BOLETO.COMPETENCIA;
      this.DADOS_CEDENTE_BOLETO.FUNDO = DADOS_BOLETO.FORMA_FINANCIAMENTO;
    }
  }

  ParcelaEstaVencida(VENCIMENTO: any) {
    let dataAtual = this.datePipe.transform(new Date(), "dd/MM/yyyy");
    let dataVENCIMENTO = this.datePipe.transform(VENCIMENTO, "dd/MM/yyyy");
    let parcelaVencida = false;

    if (dataAtual < dataVENCIMENTO) {
      parcelaVencida = true;
    }

    return parcelaVencida;
  }

  isTypedArray(obj: any) {
    return obj.type == "application/pdf";
  }

  //#endregion Boleto Arrecadação

  PerguntasFrequentes() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetPerguntasFrequentes",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.perguntasFrequentes = data;
        },
        (error) => {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhuma pergunta cadastrada!",
          });
        }
      )
      .add(() => (this.Mostrar = false));
  }

  Informativos() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetInformativos",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.informativos = data;
        },
        (error) => {}
      )
      .add(() => (this.Mostrar = false));
    this.menssagemLida();
  }

  Links() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetLinks",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.links = data;
        },
        (error) => {}
      )
      .add(() => (this.Mostrar = false));
  }

  tabela: InformPortal[] = [];

  menssagemLida() {
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    this.tabela = [];
    var locastorages = JSON.stringify(sessionStorage.getItem("AcessoAdm"));

    this.informativos.forEach((x) => {
      this.tabela.push({
        DATA_VISUALIZACAO: x.DATA_VISUALIZACAO,
        INFORME_ID: Number(x.INFORME_ID),
        USR_LOGIN_ID: Number(this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID),
      });
    });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/PostNotificarInformativos",
        JSON.stringify(this.tabela),
        options
      )
      .subscribe(
        (result) => console.log(result),
        (error) => console.log(error)
      );
  }

  RecadastramentoOnline() {
    this.UtilServico.Get("Recadastramento").subscribe(
      (data) => {
        this.recadastramentoOnline = data;
        if (this.recadastramentoOnline.length > 0) {
          let mesAtual = new Date().getMonth() + 1;
          let mesAniversario =
            new Date(this.UtilDadosLogado.DadosAcesso().DATA_NASC).getMonth() +
            1;
          this.recadastramentoOnlineExibir =
            this.recadastramentoOnline[0].RECAD_ONLINE_ANIVERSARIO == 1
              ? mesAtual == mesAniversario
              : true;
          this.agendDataIni =
            this.recadastramentoOnline[0].DATA_COMPARECIMENTO_INICIO;
          this.agendDataFim =
            this.recadastramentoOnline[0].DATA_COMPARECIMENTO_FIM;
          this.agendDescricao = this.recadastramentoOnline[0].DESCRICAO;
        } else this.recadastramentoOnlineExibir = false;
      },
      (error) => {}
    );
  }

  ObterDadosPessoais() {
    this.Pessoas();
    this.UtilServico.Post(
      "Dependentes",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      })
    ).subscribe(
      (data) => {
        this.dependentes = data;
      },
      (error) => {}
    );
  }

  AgendarRecadastramento() {
    this.Mostrar = true;
    let body = this.DADOSPESSOAIS;
    this.UtilServico.Put(
      "PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID,
      body
    ).subscribe((data) => {});
    this.UtilServico.Post(
      "AgendarRecadastramento",
      JSON.stringify({
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        NOME: this.UtilDadosLogado.DadosAcesso().NOME,
        LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
        DATA_CALC: this.recadastramentoOnlineData,
      })
    ).subscribe(
      (data) => {
        if (data.Codigo == 0) {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.EmitirComprovanteAgendamento(data.Msg);
          this.Mostrar = false;
          swal.fire({
            title: "Obrigado!",
            type: "success",
            text: "Agendamento realizado com sucesso!",
          });
        }
      },
      (error) => {
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Não foi agendar o recadastramento!",
        });
      }
    );
  }

  public EmitirComprovanteAgendamento(protocolo) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/EmitirComprovanteAgendamento",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          NOME: this.UtilDadosLogado.DadosAcesso().NOME,
          LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
          DATA_CALC: this.recadastramentoOnlineData,
          ESPECIAL: protocolo,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "warning",
            text: "Não foi emitir o comprovante de recadastramento!",
          });
        }
      );
  }

  //#region Solicitar Beneficio
  AssuntoSolicitarBeneficio() {
    this.UtilServico.Get("GetAssuntoSolicitarBeneficio").subscribe(
      (data) => (this.assuntoSolicitacaoBenef = data),
      (error) => {}
    );
  }
  setAssuntoSolicitarBeneficio($event) {
    this.selectedAssuntoSolicitacaoBenefId = $event;
    for (var i = 0; i < this.assuntoSolicitacaoBenef.length; i++) {
      if (this.assuntoSolicitacaoBenef[i].ASSUNTO_ID == $event) {
        this.SOLIC_BENEF.ASSUNTO_ID =
          this.assuntoSolicitacaoBenef[i].ASSUNTO_ID;
        this.selectedAssuntoSolicitacaoBenef =
          this.assuntoSolicitacaoBenef[i].NOME;
      }
    }
  }

  SolicitarBeneficio() {
    if (this.SOLIC_BENEF.ASSUNTO_ID && this.SOLIC_BENEF.DSC) {
      this.Mostrar = true;
      this.UtilServico.Post(
        "GetSolicitarBeneficio",
        JSON.stringify({
          ASSUNTO_ID: this.SOLIC_BENEF.ASSUNTO_ID,
          DATA_ABERTURA: this.SOLIC_BENEF.DATA_ABERT,
          DSC_ASSUNTO: this.SOLIC_BENEF.DSC,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        })
      ).subscribe(
        (data) => {
          let mensagemRetorno = data;
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: mensagemRetorno.length ? "error" : "success",
            text: mensagemRetorno.length
              ? mensagemRetorno
              : "Sua solicitação foi salva e encaminhada para análise!",
          });
        },
        (error) => {
          this.Mostrar = false;
          console.log(error);
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível registrar sua solicitação. Favor verificar se as informações estão preenchidas corretamente!",
          });
        }
      );
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "Preencha os campos vazios para continuar.",
      });
    }
  }

  RecadastamentoOnline() {
    let categoriaSegurado = this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID;
    let apresentaLinkCategoria = this.parametros;
    let recadastramento = this.parametros.ENDERECO_ACESSO_RECADONLINE;

    if (
      categoriaSegurado == 1 &&
      apresentaLinkCategoria.EFETIVO_ACESSO_RECADONLINE == "S"
    ) {
      window.open(recadastramento);
    }
    if (
      categoriaSegurado == 2 &&
      apresentaLinkCategoria.INATIVO_ACESSO_RECADONLINE == "S"
    ) {
      window.open(recadastramento);
    }
    if (
      categoriaSegurado == 3 &&
      apresentaLinkCategoria.PENSIONISTA_ACESSO_RECADONLINE == "S"
    ) {
      window.open(recadastramento);
    }
  }
  //#endregion Solicitar Beneficio

  agendaAtendimento() {

    const hash = btoa(
      this.UtilDadosLogado.DadosAcesso().NOME +
      `|` +
      this.UtilDadosLogado.DadosAcesso().DATA_NASC +
      `|` +
      this.UtilDadosLogado.DadosAcesso().LOGIN
    );
    window.open(
      this.parametros.PORTAL_AGENDAR_ATENDIMENTO_URL +
      `?cpf=` +
      this.UtilDadosLogado.DadosAcesso().LOGIN +
      `&dataNasc=` +
      this.datePipe.transform(
        this.UtilDadosLogado.DadosAcesso().DATA_NASC,
        "dd/MM/yyyy"
      )
    );
  }

  ConfigurarModalPdf(data: any, title: string) {
    var fileReader = new FileReader();
    fileReader.onload = () => {
      this.bytesPdf = fileReader.result;
      this.bytesPdfTitle = title;
    };
    fileReader.readAsArrayBuffer(data);
  }

  public TransformaSimulacaoId(data: any): Promise<ResultadoSimulacao> {
    return new Promise((resolve) => {
      const file = data;
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        const resultado = JSON.parse(fileReader.result.toString());
        const elementosJson = Object.values(resultado.d);
        let resultadoSimulacao: ResultadoSimulacao;
        resultadoSimulacao = {
          simulacaoId: elementosJson[1].toString(),
          mensagemErro: elementosJson[2].toString(),
          novaDataCalculo: elementosJson[3].toString()
        };
        resolve(resultadoSimulacao);
      }
      fileReader.readAsText(file, "UTF-8");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/inicial/inicial.component.ts